import { render } from "./TermsOfService.vue?vue&type=template&id=c9656fe2"
const script = {}

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__